import moment from 'moment';
import { history } from './history';
// @ts-check

/** @type {import('./types/reports.types').ReportsContent} */
const summary = () => {
  return [
    {
      label: 'Summary',
      icon: 'dashboard',
      pdf: { title: 'Summary', colsWidth: [20, 100, 100, 100, 100] },
      view: {
        type: 'table',
        content: summaryTable(),
      },
    },
    {
      label: 'Trips',
      icon: 'event',
      pdf: { title: 'Summary - Trips', colsWidth: [100, 100, 100, 100, 100] },
      view: {
        type: 'table',
        content: tripsTable(),
      },
    },
    {
      label: 'Idling',
      icon: 'event',
      pdf: { title: 'Summary - Idling', colsWidth: [100, 100, 100, 100, 100] },
      view: {
        type: 'table',
        content: idlingTable(),
      },
    },
    {
      label: 'Parking',
      icon: 'event',
      pdf: { title: 'Summary - Parking', colsWidth: [100, 100, 100, 100, 100] },
      view: {
        type: 'table',
        content: parkingTable(),
      },
    },
    {
      label: 'Chart',
      icon: 'event',
      pdf: { title: 'Summary', colsWidth: [100, 100, 100, 100, 100] },
      view: {
        type: 'chart',
        content: [{ header: 'tableHeader', field: 'objectKey' }],
      },
    },
  ];
};

const summaryTable = () => {
  return [
    { field: 'no', header: 'No.', textAlign: 'Left' },
    {
      field: 'assetName',
      header: 'Asset',
      width: 'max',
    },
    {
      field: 'time',
      header: 'Time',
    },
    {
      field: 'workTime',
      header: 'Work Time',
      visible: false,
    },
    {
      field: 'daysUsage',
      header: 'Days Usage',
    },
    {
      field: 'topSpeed',
      header: 'Top Speed',
    },
    {
      field: 'tripDistance',
      header: 'Trips Distance',
    },
    {
      field: 'tripCount',
      header: 'Trips Count',
    },
    {
      field: 'tripTime',
      header: 'Trips Duration',
    },
    {
      field: 'idlingCount',
      header: 'Idling Count',
    },
    {
      field: 'idlingTime',
      header: 'Idling Duration',
    },
    {
      field: 'idlingWastage',
      header: 'Idling Wastage (RM)',
    },
    {
      field: 'parkCount',
      header: 'Park Count',
    },
    {
      field: 'parkTime',
      header: 'Park Duration',
    },
    {
      field: 'startLocation',
      header: 'Start Location',
    },
    {
      field: 'coordinates',
      header: 'Coord',
      template: { component: 'GoogleMapLink' },
    },
    {
      field: 'endLocation',
      header: 'End Location',
    },
    {
      field: 'coordinates2',
      header: 'Coord',
      template: { component: 'GoogleMapLink' },
    },
    {
      header: 'Actions',
      textAlign: 'Center',
      template: {
        component: 'ActionButtons',
        data: [
          {
            text: 'View Trip Breakdown',
            icon: 'icon-truck',
            iconPack: 'feather',
            click: {
              component: 'ModalTable',
              data: {
                args: {
                  summary: true,
                  type: 0,
                  title: 'Trips',
                  table: tripsTable(),
                  colsWidth: [60, 80, 60, 40, 40, 60, 120, 60, 60],
                  data: 'tripData',
                },
                onReady: summaryActions,
              },
            },
          },
          {
            text: 'View Idling Breakdown',
            icon: 'icon-pause-circle',
            iconPack: 'feather',
            click: {
              component: 'ModalTable',
              data: {
                args: {
                  summary: true,
                  type: 1,
                  title: 'Idling',
                  table: idlingTable(),
                  colsWidth: [60, 80, 60, 120, 60, 60],
                  data: 'idlingData',
                },

                onReady: summaryActions,
              },
            },
          },
          {
            text: 'View Parking Breakdown',
            icon: 'icon-stop-circle',
            iconPack: 'feather',
            click: {
              component: 'ModalTable',
              data: {
                args: {
                  summary: true,
                  type: 2,
                  title: 'Parking',
                  table: parkingTable(),
                  colsWidth: [60, 80, 60, 120, 60, 60],
                  data: 'parkData',
                  noAction: true,
                },

                onReady: summaryActions,
              },
            },
          },
        ],
      },
    },
  ];
};
const tripsTable = () => {
  return [
    { field: 'assetName', header: 'Asset' },
    {
      field: 'tripTime',
      header: 'Time',
    },
    {
      field: 'tripMin2',
      header: 'Duration',
    },
    {
      field: 'tripDistance',
      header: 'Distance',
    },
    {
      field: 'tripIdlingCount',
      header: 'Idling Count',
    },
    {
      field: 'tripStartFuel',
      header: 'Fuel - Start (L)',
      visible: false,
    },
    {
      field: 'tripEndFuel',
      header: 'Fuel - End (L)',
      visible: false,
    },
    {
      field: 'tripRefuelsFuel',
      header: 'Fuel - Refuel (L)',
      visible: false,
    },
    {
      field: 'tripFuelConsumption',
      header: 'Fuel Consumption (L)',
      visible: false,
    },
    {
      field: 'topSpeed',
      header: 'Top Speed',
    },
    {
      field: 'tripIdlingMin2',
      header: 'Idling Duration',
    },
    {
      field: 'startLocation',
      header: 'Start Location',
    },
    {
      field: 'coordinates',
      header: 'Coord',
      template: { component: 'GoogleMapLink' },
    },
    {
      field: 'endLocation',
      header: 'End Location',
    },
    {
      field: 'coordinates2',
      header: 'Coord',
      template: { component: 'GoogleMapLink' },
    },
    {
      field: 'status',
      header: 'Status',
    },
    {
      header: 'Actions',
      template: {
        component: 'ActionButtons',
        data: [
          {
            text: 'View Trip Playback',
            icon: 'icon-map',
            iconPack: 'feather',
            click: {
              component: 'PlayBackV2',
              data: { onReady: getPlayback },
            },
          },
          {
            text: 'View History/Details',
            icon: 'icon-list',
            iconPack: 'feather',
            click: {
              component: 'ModalTable',
              data: {
                args: {
                  summary: false,
                  table: history()[0].view.content,
                  colsWidth: history()[0].pdf.colsWidth,
                  type: 'History',
                  data: 'historyData',
                  noAction: true,
                },
                onReady: getModalTableData,
              },
            },
          },
        ],
      },
    },
  ];
};
const idlingTable = () => {
  return [
    { field: 'assetName', header: 'Asset' },
    {
      field: 'idlingTime',
      header: 'Time',
    },
    {
      field: 'idlingMin2',
      header: 'Duration',
    },
    {
      field: 'idlingWastage',
      header: 'Idling Wastage (RM)',
    },
    {
      field: 'startLocation',
      header: 'Start Location',
    },
    {
      field: 'coordinates',
      header: 'Coord',
      template: { component: 'GoogleMapLink' },
    },
    {
      field: 'status',
      header: 'Status',
    },
  ];
};
const parkingTable = () => {
  return [
    { field: 'assetName', header: 'Asset' },
    {
      field: 'parkTime',
      header: 'Time',
    },
    {
      field: 'parkMin2',
      header: 'Duration',
    },
    {
      field: 'startLocation',
      header: 'Location',
    },
    {
      field: 'coordinates',
      header: 'Coord',
      template: { component: 'GoogleMapLink' },
    },
    {
      field: 'status',
      header: 'Status',
    },
  ];
};

const summaryActions = async (self) => {
  return new Promise((resolve) => {
    let param = self.data.data.args;
    let args = self.data.rowData;
    let assetName = args.assetName;
    let reports = self.reportsContent.reportsData;
    let report = reports[param.type + 1];
    let array = report.filter((obj) => obj.assetName === assetName);

    let modal = JSON.parse(JSON.stringify(self.modalTableApi));

    // return array;
    modal.reportData = array;
    modal.table.content = deepClone(param.table);
    if (!param.noAction) {
      modal.table.content.pop();
    }
    modal.table.content.forEach((e) => {
      if (e.header == 'Coord' || e.header == 'Coords') {
        e.template.data = { component: 'GoogleMapEmbed' };
      }
    });
    modal.pdf.colsWidth = param.colsWidth;

    modal.title = `${param.title} - ${args.assetName}`;
    modal.pdf.title = modal.title;
    self.onReadyData = modal;

    resolve(true);
  });
};

const getModalTableData = async (self) => {
  let param = self.data.data.args;
  let args = self.data.rowData;
  let url = param.summary
    ? 'getIndividualSummaryBreakdown'
    : 'getIndividualHistoryBreakdown';
  let options = param.summary
    ? {
        timeRange: self.timeRange,
        uid: self.userInfo.uid,
        unitId: args.unitId,
        assetId: args.assetId,
        assetName: args.assetName,
        configuration: self.configuration,
        type: param.type,
        geoPOIData: self.geoPOIData,
      }
    : {
        timeRange: tripTimerange(args.tripTime).timeRange,
        uid: self.userInfo.uid,
        units: [args.unitId],
        geoPOIData: self.geoPOIData,
        type: param.type,
        configuration: self.configuration,
      };
  let modal = JSON.parse(JSON.stringify(self.modalTableApi));
  let field = {
    Trips: 'tripCount',
    Idling: 'idlingCount',
    Parking: 'parkCount',
  };
  return new Promise((resolve) => {
    if (args[field[param.type]] && args[field[param.type]] == 0) {
      self.$vs.notify({
        title: 'Error',
        text: 'No data available',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning',
      });
      resolve(false);
    } else {
      // self.isLoading = true;
      // console.log(options);
      self.$http
        .post('report/table', options)
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            let breakdownData = [];
            breakdownData.push({
              assetId: args.assetId,
              type: param.type,
              assetName: args.assetName,
              arr: response.data.reportData,
            });
            // console.log(response);
            breakdownData[0].arr.forEach((e) => {
              modal.reportData.push(e);
            });
            // console.log(breakdownData);
            // modal.reportData = breakdownData;
            modal.table.content = deepClone(param.table);
            if (!param.noAction) {
              modal.table.content.pop();
            }
            modal.table.content.forEach((e) => {
              if (e.header == 'Coord' || e.header == 'Coords') {
                e.template.data = { component: 'GoogleMapEmbed' };
              }
            });
            modal.pdf.colsWidth = param.colsWidth;
            // self.forceRender += 1;
            // self.activeTab = self.breakdownData.length + 5;
            // self.isLoading = false;

            modal.title = `${param.type} - ${args.assetName}`;
            modal.pdf.title = modal.title;
            self.onReadyData = modal;

            resolve(true);
          } else {
            // self.isLoading = false;
            if (response.data.error) {
              self.$vs.notify({
                title: 'Error',
                text: 'Try again later.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
              });
              resolve(false);
            } else {
              self.$vs.notify({
                title: 'Error',
                text: 'Try again later.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
              });
              resolve(false);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
          // self.isLoading = false;

          self.$vs.notify({
            title: 'Error',
            text: 'Try again later.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
          resolve(false);
        });
    }
  });
};

const tripTimerange = (tripTime) => {
  const time = tripTime.split('-');
  const timeRange = [0, 0];
  // time[0] = time[0].substring(0, time[0].length);
  // time[1] = time[1].substring(1, time[1].length);
  timeRange[0] = moment(time[0], 'DD/MM/YYYY | hh:mm:ss').toISOString();
  timeRange[1] = moment(time[1], 'DD/MM/YYYY | hh:mm:ss').toISOString();
  return { timeRange, time };
};

const getPlayback = async (self) => {
  let args = self.data.rowData;
  // console.log(args);
  return new Promise((resolve) => {
    self.isLoading = true;
    self.$http
      .post(`singleUnitPlayback3`, {
        timeRange: tripTimerange(args.tripTime).timeRange,
        geoPOIData: self.geoPOIData,
        configuration: {
          speedType: '',
          speedLimit: 0,
        },
        platform: 'Web',
        uid: undefined,
        units: [args.unitId],
        // mode: 1,
      })
      .then(function (response) {
        if (response.status == 200 && response.data.success) {
          self.selected.routeArray = response.data.routeArray;
          self.selected.routePath = response.data.routePath;
          self.selected.assetName = args.assetName;
          self.popupActive = true;
          self.isLoading = false;
          self.loadMap = true;
          self.onReadyData.title = `Overspeeding - ${args.assetName}`;
          // console.log(self);
          // console.log(tripTimerange(args.tripTime));
          self.selected.timeRange = tripTimerange(args.tripTime).timeRange;
          resolve(true);
        } else {
          self.isLoading = false;
          if (response.data.error) {
            self.$vs.notify({
              title: 'Error',
              text: 'Try again later.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
            resolve(false);
          } else {
            self.$vs.notify({
              title: 'Error',
              text: 'Try again later.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
            resolve(false);
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        self.isLoading = false;

        self.$vs.notify({
          title: 'Error',
          text: 'Try again later.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
        resolve(false);
      });
  });
};

function deepClone(obj, clonesMap = new WeakMap()) {
  // Check if the object is already cloned
  if (clonesMap.has(obj)) {
    return clonesMap.get(obj);
  }

  // Handle non-object types and null
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  // Handle special objects like Date
  if (obj instanceof Date) {
    return new Date(obj);
  }

  // Handle arrays
  if (Array.isArray(obj)) {
    const arrClone = [];
    clonesMap.set(obj, arrClone);
    for (let i = 0; i < obj.length; i++) {
      arrClone[i] = deepClone(obj[i], clonesMap);
    }
    return arrClone;
  }

  // Handle regular objects
  const objClone = {};
  clonesMap.set(obj, objClone);
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      objClone[key] = deepClone(obj[key], clonesMap);
    }
  }

  return objClone;
}

export { summary };
